<template>
  <b-card @click="$emit('productSelect', service.productid)" :style="'height: max-content'" :body-class="'rounded' + (isActive ? ' outline-' + service.class : '') + (selectedProduct != null && selectedProduct.productid === service.productid ? ' adjustForSelected' : '')" :class="service.class + (selectedProduct != null && selectedProduct.productid === service.productid ? ' selectedOutline' : ' hover-' + service.class)" v-if="service != null">
    <b-card-header :class="service.class + '-header m-4'">{{ service.name }}</b-card-header>
    <slot name='description'>
      <div class="ml-4 mr-3">
        {{ service.description }}
        <br />
        {{ service.devices != null ? service.devices : 'Unlimited' }} devices
        <br />
        Upload {{ service.upDescription }}
        <br />
        Download {{ service.downDescription }}
        <br />
      </div>
      <div v-if="selectedProduct.productid == service.productid" class="selection-details">
        <span style="display: inline-block" class="ml-4 mr-3 mt-3"> Monthly cost of £{{monthlyPrice.toFixed(2)}}</span>
        <div v-if="activeproduct == null">
          <span style="display: inline-block" class="ml-4 mr-3">Pay £{{price.toFixed(2)}} for {{datediff(until)}} days until {{$options.filters.dateFormat(until, 'dddd D MMM YYYY')}}{{ account.flexiplan != null && account.flexiplan.credits > 0 ? ', adjusted for existing credits' : '.' }}</span>
        </div>
        
        <div v-else-if="isLastDayOfMonth(new Date(activeuntil))">
          <span v-if="activeproduct.productid >= service.productid" style="display: inline-block" class="ml-4 mr-3 mt-3">Subscribe for £{{price.toFixed(2)}}</span>
          <div v-else>
            <span style="display: inline-block" class="ml-4 mr-3">Pay £{{price > monthlyPrice ? (price - monthlyPrice).toFixed(2) : price.toFixed(2)}} now to upgrade {{datediff(activeuntil)}} days until {{$options.filters.dateFormat(new Date(activeuntil), 'dddd D MMM YYYY')}}{{price > monthlyPrice ? ', plus £' + monthlyPrice.toFixed(2) + ' for next month' : ''}}</span>
          </div>
          <span style="display: inline-block" class="ml-4 mr-3">Renews on {{$options.filters.dateFormat(until, 'dddd D MMM YYYY')}}</span>
          <span v-if="activeproduct.productid > service.productid" style="display: inline-block" class="ml-4 mr-3">You will retain your current plan until {{$options.filters.dateFormat(new Date(activeuntil), 'dddd D MMM YYYY')}}</span>
          <div v-else><br/></div>
        </div>

        <div v-else>
          <div v-if="activeproduct.productid >= service.productid">
            <span style="display: inline-block" class="ml-4 mr-3">Pay £{{price.toFixed(2)}} now for {{ datediff(until) }} days until {{$options.filters.dateFormat(until, 'dddd D MMM YYYY')}}</span>
            <span v-if="activeproduct.productid > service.productid" style="display: inline-block" class="ml-4 mr-3">You will retain your current plan until {{$options.filters.dateFormat(new Date(activeuntil), 'dddd D MMM YYYY')}}</span>
          </div>
          <div v-if="activeproduct.productid < service.productid">
            <span style="display: inline-block" class="ml-4 mr-3">Pay £{{price > monthlyPrice ? (price - monthlyPrice).toFixed(2) : price.toFixed(2)}} now to upgrade {{datediff(activeuntil)}} days until {{$options.filters.dateFormat(until, 'dddd D MMM YYYY')}}{{price > monthlyPrice ? ', plus £' + monthlyPrice.toFixed(2) + ' for next month' : ''}}</span>
          </div>
        </div>
      </div>
      <div v-else class="no-selection-details">
        <span style="display: inline-block" class="ml-4 mr-3 mt-3"> Monthly cost of £{{monthlyPrice.toFixed(2)}}</span>
      </div>
    </slot>
    <slot name='action'>
    </slot>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AdjustProductCard',
  props: {
    service: {
        type: Object, // name, descripion, class
        required: true
    },
    isActive: {
        type: Boolean,
        default: false
    },
    price: {
      type: Number,
      required: true
    },
    monthlyPrice: {
      type: Number,
      required: true
    },
    until: {
      type: Date,
      required: true
    },
    // datediff: {
    //   type: Number,
    //   default: null
    // }
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      activeuntil: "plan/getActiveUntil",
      activeproduct: "plan/getActiveProduct",
      selectedProduct: "pricing/getChosenProduct"
    })
  },
  methods: {
    proRataDateDiff() {
      return this.activeuntil != null ? Math.round((new Date(this.until) - new Date(this.activeuntil)) / (1000 * 60 * 60 * 24)) : Math.round((new Date(this.until) - new Date()) / (1000 * 60 * 60 * 24) );
    },
    datediff(date) {
      return date != null ? Math.ceil((new Date(date) - new Date()) / (1000 * 60 * 60 * 24)) : 0;
    },
    isLastDayOfMonth(date) {
      const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return date.getDate() === lastDayOfMonth.getDate();
    }
  }
}
</script>

<style lang="scss" scoped>

.svc1 {
  background: linear-gradient(to right, #373b44, #38AADE) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 5px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc2 {
  background: linear-gradient(to right, #a1540b, #EE811A) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px !important;
  height: 100%;
  margin: 12px;
  padding: 5px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc3 {
  background: linear-gradient(to right, #517043, #5DB12F) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 5px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc4 {
  background: linear-gradient(to right, #a08b00 5%, mix(#a08b00, #cdb970, 50%) 20%, #cdb970 40%) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 5px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}

.svc1-header {
  border: solid white 2px;
  background: linear-gradient(to left, #526797, #3f66ad) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.svc2-header {
  border: solid white 2px;
  background: linear-gradient(to left, #a75a12, #EE811A) !important;
  border-radius: 14px 14px 14px 14px;
  box-shadow: 12px 10px 8px #373b44;
}

.svc3-header {
  border: solid white 2px;
  background: linear-gradient(to left, #79a560, #5DB12F) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.svc4-header {
  border: solid white 2px;
  background: linear-gradient(to left, #867a50, #ccba78) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.card-body {
  padding: 0 0 0 0 !important;
  border-radius: 20px 20px 20px 20px !important;
  -moz-border-radius: 20px 20px 20px 20px;
  -webkit-border-radius: 20px 20px 20px 20px;
}

.product-footer-svc1 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  -moz-border-radius-topright: 140px 60px !important;
  -webkit-border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  -moz-border-radius-topleft: 140px 60px !important;
  -webkit-border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  -moz-border-radius-bottomleft: 20px !important;
  -webkit-border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  -moz-border-radius-bottomright: 20px !important;
  -webkit-border-bottom-right-radius: 20px !important;
  background: #4972c0;
  border: 1px black solid;
}

.product-footer-svc2 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #EE811A;
  border: 1px black solid;
}

.product-footer-svc3 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #4f9e25;
  border: 1px black solid;
}

.product-footer-svc4 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #ccba78;
  border: 1px black solid;
}

.active-product-footer {
  border: solid #551355 4px;
}

.selectedOutline {
  border: yellowgreen 8px solid;
}

.adjustForSelected {
  margin: -7px;
}

.hover-svc1:hover {
  box-shadow: 0 0 20px 10px #4972c0;
}

.hover-svc2:hover {
  box-shadow: 0 0 20px 10px #EE811A;
}

.hover-svc3:hover {
  box-shadow: 0 0 20px 10px #4f9e25;
}

.hover-svc4:hover {
  box-shadow: 0 0 20px 10px #ccba78;
}

.selection-details {
  min-height: 8rem;
  height: 8rem;
  border-radius: 8px;
}

.no-selection-details {
  min-height: 8rem;
  height: 8rem;
  border-radius: 8px;
}
</style>